"use client";

import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { Icon } from "@/components/ui/icon";
import { relatedServices } from "@/lib/data/homepage";

/**
 * Related Services — Rich hover cards. Each card has a description
 * that becomes visible on hover, plus a CTA link.
 */
export function RelatedServices() {
  const accents = [
    "var(--color-cyan)",
    "var(--color-purple)",
    "var(--color-amber)",
    "var(--color-emerald)",
    "var(--color-crimson)",
    "var(--color-coral)",
  ];
  return (
    <section id="related-services" className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny text-[var(--color-emerald)]">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--color-emerald)]" />
            Related Services
          </span>
          <h2 className="mt-6">
            Expand Your Perception Advantage
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {relatedServices.map((s, i) => (
            <Reveal key={s.title} delay={i * 60}>
              <a
                href="#capabilities"
                className="group block rounded-2xl glass p-5 h-full relative overflow-hidden card-glow hover:scale-[1.02] transition-all cursor-pointer"
                style={{ ["--glow" as string]: accents[i] }}
              >
                <div className="flex items-start gap-3">
                  <span
                    className="grid place-items-center h-10 w-10 rounded-lg shrink-0 transition-transform group-hover:scale-110"
                    style={{
                      background: `color-mix(in oklch, ${accents[i]} 18%, transparent)`,
                      boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accents[i]} 35%, transparent)`,
                    }}
                  >
                    <Icon name={s.icon} className="h-5 w-5" style={{ color: accents[i] }} />
                  </span>
                  <div>
                    <h3>{s.title}</h3>
                    <p className="mt-1.5 text-caption leading-relaxed text-[rgb(var(--fg-muted))]">{s.desc}</p>
                  </div>
                </div>
                <div
                  className="mt-3 eyebrow-tiny font-bold flex items-center gap-1 opacity-60 group-hover:opacity-100 transition-opacity"
                  style={{ color: accents[i] }}
                >
                  Explore →
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
}
